import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, useQuery } from '@core/api';
import Registry from '@core/registry';
import { createContext, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '../user/actions/UserActions.js';
export var UserContext = /*#__PURE__*/ createContext({
    query: undefined
});
/**
 * This hook provides the user model, separated from its privileges and access.
 * @returns {UserModel}
 */ export var useUserModel = function useUserModel() {
    var _context_query;
    var context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    if (!((_context_query = context.query) === null || _context_query === void 0 ? void 0 : _context_query.data)) {
        throw new Error('User data is not available');
    }
    return context.query.data;
};
export var UserProvider = function UserProvider(param) {
    var children = param.children;
    var dispatch = useDispatch();
    var userQuery = useQuery({
        queryKey: [
            'init',
            'user'
        ],
        queryFn: function queryFn() {
            return _async_to_generator(function() {
                var user;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Platform.user.get()
                            ];
                        case 1:
                            user = _state.sent();
                            dispatch(updateUser(user));
                            Registry.register('userModel', user);
                            return [
                                2,
                                user
                            ];
                    }
                });
            })();
        },
        initialData: Registry.get('userModel', {
            optional: true
        }),
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsx(UserContext.Provider, {
        value: {
            query: userQuery
        },
        children: children
    });
};

//# sourceMappingURL=UserContext.js.map